import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyValuePair',
  standalone: false,
})
export class KeyValueFilterPipe implements PipeTransform {
  transform(item: any): any {
    return Object.keys(item).map((key) => {
      let pair: { key: number | string; value: any } = {
        key: key,
        value: item[key],
      };

      return pair;
    });
  }
}
